<template>
  <div class="card dash-widget">
    <div class="card-body">
      <span class="dash-widget-icon">
        <i class="fa fa-whatsapp"></i>
      </span>
      <div class="dash-widget-info">
        <h5 v-if="!!loadingStatus" class="text-success">
          <Skeleton :count="1" :width="'100px'" />
        </h5>
        <h5 v-else :class="(isOnlineData.status==1)?'text-success':'text-danger'">
          <i class="fa fa-signal"></i>
          {{isOnlineData.message}}
        </h5>

        <ul class="team-members">
          <li v-if="(isOnlineData.status==1)">
            <a
              href="javascript:void(0)"
              @click="logout(licenseInfo.license_phone_number)"
              title="Logout"
            >
              <i class="text-danger fa fa-sign-out"></i>
            </a>
          </li>
          <li>
            <a @click="isOnline(licenseInfo.license_phone_number)" title="Check Status">
              <i class="text-info fa fa-refresh"></i>
            </a>
          </li>
          <li>
            <a
              id="btnScanQrcodeWa"
              href="#"
              data-toggle="modal"
              data-target="#scanQrcodeWa"
              style="display:none;"
            >
              <i class="text-info fa fa-qrcode"></i>
            </a>
            <a href="javascript:void(0)" @click="login(licenseInfo.id)" title="Scan Qrcode">
              <i class="text-info fa fa-qrcode"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div id="scanQrcodeWa" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="fa fa-whatsapp"></i> Whatsapp Qrcode
            </h5>
            <button
              id="btnCloseScanQrcodeWa"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-8">
                <ol class="_2A31C">
                  <li>Make sure your whatsapp phone number is {{licenseInfo.license_phone_number}}</li>
                  <li class="QtrYx">Open WhatsApp on your phone</li>
                  <li class="QtrYx">
                    <span dir="ltr" class="i0jNr">
                      Tap
                      <strong>
                        <span dir="ltr" class="i0jNr">
                          Menu
                          <span class="_30yMe">
                            <svg height="24px" viewBox="0 0 24 24" width="24px">
                              <rect fill="#f2f2f2" height="24" rx="3" width="24" />
                              <path
                                d="m12 15.5c.825 0 1.5.675 1.5 1.5s-.675 1.5-1.5 1.5-1.5-.675-1.5-1.5.675-1.5 1.5-1.5zm0-2c-.825 0-1.5-.675-1.5-1.5s.675-1.5 1.5-1.5 1.5.675 1.5 1.5-.675 1.5-1.5 1.5zm0-5c-.825 0-1.5-.675-1.5-1.5s.675-1.5 1.5-1.5 1.5.675 1.5 1.5-.675 1.5-1.5 1.5z"
                                fill="#818b90"
                              />
                            </svg>
                          </span>
                        </span>
                      </strong> or
                      <strong>
                        <span dir="ltr" class="i0jNr">
                          Settings
                          <span class="_30yMe">
                            <svg width="24" height="24" viewBox="0 0 24 24">
                              <rect fill="#F2F2F2" width="24" height="24" rx="3" />
                              <path
                                d="M12 18.69c-1.08 0-2.1-.25-2.99-.71L11.43 14c.24.06.4.08.56.08.92 0 1.67-.59 1.99-1.59h4.62c-.26 3.49-3.05 6.2-6.6 6.2zm-1.04-6.67c0-.57.48-1.02 1.03-1.02.57 0 1.05.45 1.05 1.02 0 .57-.47 1.03-1.05 1.03-.54.01-1.03-.46-1.03-1.03zM5.4 12c0-2.29 1.08-4.28 2.78-5.49l2.39 4.08c-.42.42-.64.91-.64 1.44 0 .52.21 1 .65 1.44l-2.44 4C6.47 16.26 5.4 14.27 5.4 12zm8.57-.49c-.33-.97-1.08-1.54-1.99-1.54-.16 0-.32.02-.57.08L9.04 5.99c.89-.44 1.89-.69 2.96-.69 3.56 0 6.36 2.72 6.59 6.21h-4.62zM12 19.8c.22 0 .42-.02.65-.04l.44.84c.08.18.25.27.47.24.21-.03.33-.17.36-.38l.14-.93c.41-.11.82-.27 1.21-.44l.69.61c.15.15.33.17.54.07.17-.1.24-.27.2-.48l-.2-.92c.35-.24.69-.52.99-.82l.86.36c.2.08.37.05.53-.14.14-.15.15-.34.03-.52l-.5-.8c.25-.35.45-.73.63-1.12l.95.05c.21.01.37-.09.44-.29.07-.2.01-.38-.16-.51l-.73-.58c.1-.4.19-.83.22-1.27l.89-.28c.2-.07.31-.22.31-.43s-.11-.35-.31-.42l-.89-.28c-.03-.44-.12-.86-.22-1.27l.73-.59c.16-.12.22-.29.16-.5-.07-.2-.23-.31-.44-.29l-.95.04c-.18-.4-.39-.77-.63-1.12l.5-.8c.12-.17.1-.36-.03-.51-.16-.18-.33-.22-.53-.14l-.86.35c-.31-.3-.65-.58-.99-.82l.2-.91c.03-.22-.03-.4-.2-.49-.18-.1-.34-.09-.48.01l-.74.66c-.39-.18-.8-.32-1.21-.43l-.14-.93a.426.426 0 00-.36-.39c-.22-.03-.39.05-.47.22l-.44.84-.43-.02h-.22c-.22 0-.42.01-.65.03l-.44-.84c-.08-.17-.25-.25-.48-.22-.2.03-.33.17-.36.39l-.13.88c-.42.12-.83.26-1.22.44l-.69-.61c-.15-.15-.33-.17-.53-.06-.18.09-.24.26-.2.49l.2.91c-.36.24-.7.52-1 .82l-.86-.35c-.19-.09-.37-.05-.52.13-.14.15-.16.34-.04.51l.5.8c-.25.35-.45.72-.64 1.12l-.94-.04c-.21-.01-.37.1-.44.3-.07.2-.02.38.16.5l.73.59c-.1.41-.19.83-.22 1.27l-.89.29c-.21.07-.31.21-.31.42 0 .22.1.36.31.43l.89.28c.03.44.1.87.22 1.27l-.73.58c-.17.12-.22.31-.16.51.07.2.23.31.44.29l.94-.05c.18.39.39.77.63 1.12l-.5.8c-.12.18-.1.37.04.52.16.18.33.22.52.14l.86-.36c.3.31.64.58.99.82l-.2.92c-.04.22.03.39.2.49.2.1.38.08.54-.07l.69-.61c.39.17.8.33 1.21.44l.13.93c.03.21.16.35.37.39.22.03.39-.06.47-.24l.44-.84c.23.02.44.04.66.04z"
                                fill="#818b90"
                              />
                            </svg>
                          </span>
                        </span>
                      </strong> and select
                      <strong>Linked Devices</strong>
                    </span>
                  </li>
                  <li class="QtrYx">Point your phone to this screen to capture the code</li>
                </ol>
              </div>
              <div class="col-md-4">
                <center>
                  <span v-if="!!loading">
                    <Skeleton :count="1" :height="'200px'" :width="'200px'" />
                  </span>
                  <span v-else>
                    <img style="width:200px;" :src="qrcodeArr.qrcode" />
                    <template>
                      <VueCountdownTimer
                        @start_callback="startCallBack('event started')"
                        @end_callback="endCallBack('event ended')"
                        :start-time="'2018-10-10 00:00:00'"
                        :end-time="endAt"
                        :interval="1000"
                        label-position="begin"
                        :end-text="'Event ended!'"
                        :day-txt="null"
                        :hour-txt="null"
                        :minutes-txt="null"
                        :seconds-txt="'seconds'"
                      />
                    </template>
                  </span>
                </center>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getWhatsappJid } from "@/utils/helper";
import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";

// import VueCountdownTimer from "vuejs-countdown-timer";
export default {
  components: {
    Skeleton
    // VueCountdownTimer
  },
  async created() {
    if (
      typeof this.$route.query.show_qr_code != "undefined" &&
      this.$route.query.show_qr_code == "1"
    ) {
      console.log("this.licenseInfo.id", this.licenseInfo.id);
      this.showQrCode = 1;
      // this.loginWithoutPopup(this.licenseInfo.id);
    }
  },
  watch: {
    showQrCode: {
      handler: function(val, oldVal) {
        if (val != oldVal) {
          var that = this;
          setTimeout(function() {
            // console.log("vallll", val);
            // console.log("lic", that.licenseInfo.id);
            that.loginWithoutPopup(that.licenseInfo.id);
          }, 200);
        }
      },
      deep: true
    },
    qrcodeArr: {
      handler: function(val, oldVal) {
        if (
          val.timeout_timestamp != 0 &&
          oldVal.timeout_timestamp != val.timeout_timestamp
        ) {
          this.endAt = val.timeout_timestamp;
        }
      },
      deep: true
    },
    licenseInfo: {
      handler: function(val, oldVal) {
        if (val.id != "") {
          this.isOnline(val.license_phone_number);
          var jid = this.getWhatsappJid(val.license_phone_number);
          var dataParams = { license_id: jid };
          //   console.log("dataParams", dataParams);
          //   console.log("dataParams", dataParams);
          this.$store.dispatch("pusher/SCAN_QRCODE", dataParams); //aktifkan pusher
        }
      },
      deep: true
    },
    SCAN_QRCODE_Data: {
      handler: function(val, oldVal) {
        // console.log("SCAN_QRCODE_Data", val, oldVal);
        this.statusScanQrCode(val);
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["SCAN_QRCODE_Data"])
  },
  props: {
    licenseInfo: {
      type: Object,
      default: 0,
      default: function() {
        return {
          id: "",
          license_name: "",
          license_phone_number: "",
          license_email: "",
          license_masa_aktif: "",
          is_unlimited: "",
          status_label: ""
        };
      }
      // required: true
    }
  },
  data() {
    return {
      showQrCode: 0,
      endAt: 0,

      loading: false,
      loadingStatus: false,
      qrcodeArr: {
        qrcode: "",
        timeout: 0,
        timeout_timestamp: 0
      },
      isOnlineData: {
        message: "",
        status: 0
      }
    };
    //  isactive : true
  },
  methods: {
    getWhatsappJid(number) {
      return getWhatsappJid(number);
    },
    async statusScanQrCode(val) {
      if (
        typeof val.status != "undefined" &&
        (val.status == 1 || val.status == 0)
      ) {
        if (val.status == 1) {
          await document.getElementById("btnCloseScanQrcodeWa").click(); // Click on the checkbox
          await this.$fire({
            title: "Success",
            text: "Phone Online",
            type: "success",
            timer: 2000
          });
        } else {
          await this.$fire({
            title: "Error",
            text: val.msg,
            type: "error",
            timer: 3000
          });
          var liContainer = document.getElementById("scanQrcodeWa");
          var isShowModal = liContainer.classList.contains("show");

          if (typeof manualClick != "undefined" || isShowModal == true) {
            await this.endCallBack("event ended");
          }
        }
        await this.isOnline(this.licenseInfo.license_phone_number);
        // setTimeout(function() {
        //   window.location.reload();
        // }, 300);
      }
    },
    startCallBack: function(x) {
      console.log(x);
    },
    endCallBack: function(x) {
      if (this.endAt > 0) {
        this.getQrcode(this.licenseInfo.id);
      }
      //   console.log(x);
    },
    async getQrcode(id, manualClick) {
      var liContainer = document.getElementById("scanQrcodeWa");
      var isShowModal = liContainer.classList.contains("show");

      if (typeof manualClick != "undefined" || isShowModal == true) {
        this.loading = await true;
        await this.$store
          .dispatch("omniwa/login", id)
          .then(response => {
            var { data } = response;
            this.qrcodeArr = data;
          })
          .catch(error => {});
        this.loading = await false;
      }
      //   console.log();
    },
    async login(id) {
      await this.$fire({
        title:
          "Are you sure you will continue this action? Another session will be destroyed.",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (typeof r.value != "undefined" && r.value == true) {
          await document.getElementById("btnScanQrcodeWa").click(); // Click on the checkbox
          await this.isOnline(this.licenseInfo.license_phone_number);
          await this.getQrcode(id, true);
        }
      });
    },
    async loginWithoutPopup(id) {
      await document.getElementById("btnScanQrcodeWa").click(); // Click on the checkbox
      await this.isOnline(this.licenseInfo.license_phone_number);
      await this.getQrcode(id, true);
    },
    async isOnline(phone) {
      this.loadingStatus = await true;

      await this.$store
        .dispatch("omniwa/isOnline", phone)
        .then(response => {
          var { data } = response;
          this.isOnlineData = data;
        })
        .catch(error => {});
      this.loadingStatus = await false;
    },
    async logout(phone) {
      await this.$fire({
        title: "Do you want to logout this whatsapp session?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (typeof r.value != "undefined" && r.value == true) {
          await this.$store
            .dispatch("omniwa/logout", phone)
            .then(response => {
              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              });
            })
            .catch(error => {});
          await this.isOnline(phone);
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/license/whatsapp.vue